import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Menu, X, ChevronDown } from "lucide-react";
import hamburger from "../assets/images/icons/hamburger.svg";
import SearchIcon from "../assets/images/icons/search.svg";
import CancelIcon from "../assets/images/icons/cross.svg";

export const Header = () => {
  const navigate = useNavigate();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isResourcesOpen, setIsResourcesOpen] = useState(false);

  const handleScroll = () => {
    setIsScrolled(window.scrollY > 90); // Change 50 to your preferred scroll value
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // For Sidebar Drawer
  const [isOpen, setIsOpen] = useState(false);

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
    document.body.classList.toggle("sidebar-open");
  };
  const token = localStorage.getItem("authToken");
  return (
    <div className="absolute inset-0 bg-gradient-to-br from-[#000322] via-[#00067E] to-[#3b82f6] overflow-hidden">
      <header className="relative z-50 px-4 md:px-8 py-4 md:py-6">
        <nav className="flex justify-between items-center">
          <div className="flex items-center">
            <Link to="/" className="flex items-center hover:opacity-90 transition-all duration-300">
              <img src={require("../assets/images/logo.png")} alt="UpNComer" className="h-7 md:h-9 w-auto drop-shadow-lg" />
            </Link>
          </div>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-8">
            <Link
              to="/distribution"
              className="text-xs text-theme_clr4 font-semibold tracking-wider"
            >
              DISTRIBUTION
            </Link>
            <Link
              to="/features"
              className="text-xs text-[#c7d2fe]/80 hover:text-[#a5b4fc] transition-all font-light tracking-wider"
            >
              FEATURES
            </Link>
            <Link
              to="/pricing"
              className="text-xs text-[#c7d2fe]/80 hover:text-[#a5b4fc] transition-all font-light tracking-wider"
            >
              PRICING
            </Link>
            <Link
              to="/our-story"
              className="text-xs text-[#c7d2fe]/80 hover:text-[#a5b4fc] transition-all font-light tracking-wider"
            >
              OUR STORY
            </Link>
            {token ? (
              <button
                type="button"
                onClick={() => navigate("/dashboard")}
                className="min-w-[84px] bg-theme_clr2 text-white text-sm font-manrope font-bold px-[16.5px] py-[7px] rounded-[12px]"
              >
                Dashboard
              </button>
            ) : (
              <>
                <Link
                  to="/login"
                  className="text-xs text-[#ffffff]/80 hover:text-[#a5b4fc] transition-all font-light tracking-wider"
                >
                  LOGIN
                </Link>
                <Link
                  to="/signup"
                  className="text-xs text-[#FA6138] border border-[#FA6138]/30 px-5 py-2.5 rounded-full hover:bg-[#FA6138]/10 transition-all font-light"
                >
                  JOIN NOW
                </Link>
              </>
            )}
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsResourcesOpen(!isResourcesOpen)}
              className="text-[#a5b4fc] hover:text-[#818cf8] transition-all p-2"
            >
              {isResourcesOpen ? (
                <X className="w-6 h-6" />
              ) : (
                <Menu className="w-6 h-6" />
              )}
            </button>
          </div>
        </nav>

        {/* Mobile Menu Dropdown */}
        {isResourcesOpen && (
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.2 }}
            className="md:hidden fixed top-[72px] left-0 right-0 bottom-0 bg-[#000456] border-t border-[#6366f1]/20 shadow-2xl overflow-y-auto"
          >
            <div className="py-4 px-6 space-y-4">
              <Link
                to="/distribution"
                className="text-xs text-theme_clr4 font-semibold tracking-wider"
              >
                DISTRIBUTION
              </Link>
              <Link
                to="/features"
                className="block text-sm text-[#c7d2fe] hover:text-[#a5b4fc] transition-all font-light tracking-wide py-2 active:bg-[#1e3a8a]/20"
                onClick={() => setIsResourcesOpen(false)}
              >
                FEATURES
              </Link>
              <Link
                to="/pricing"
                className="block text-sm text-[#c7d2fe] hover:text-[#a5b4fc] transition-all font-light tracking-wide py-2 active:bg-[#1e3a8a]/20"
                onClick={() => setIsResourcesOpen(false)}
              >
                PRICING
              </Link>
              <Link
                to="/our-story"
                className="block text-sm text-[#c7d2fe] hover:text-[#a5b4fc] transition-all font-light tracking-wide py-2 active:bg-[#1e3a8a]/20"
                onClick={() => setIsResourcesOpen(false)}
              >
                OUR STORY
              </Link>

              {/* Resources Submenu */}
              {/* <div className="py-2 border-t border-[#6366f1]/20">
                <div className="text-sm text-[#818cf8] font-light tracking-wide mb-2">
                  RESOURCES
                </div>
                {[
                  { label: "Tutorials", path: "/tutorials" },
                  { label: "Case Studies", path: "/case-studies" },
                  { label: "Blog", path: "/blog" },
                  { label: "Community Updates", path: "/community-updates" },
                  { label: "Help Center", path: "/help-center" },
                ].map((item, i) => (
                  <Link
                    key={i}
                    to={item.path}
                    className="block text-sm text-[#c7d2fe] hover:text-[#a5b4fc] transition-all font-light tracking-wide py-2 pl-4 active:bg-[#1e3a8a]/20"
                    onClick={() => setIsResourcesOpen(false)}
                  >
                    {item.label}
                  </Link>
                ))}
              </div> */}

              {/* Auth Buttons */}
              <div className="pt-4 border-t border-[#6366f1]/20 space-y-3">
                {token ? (
                  <button
                    type="button"
                    onClick={() => navigate("/dashboard")}
                    className="min-w-[84px] bg-theme_clr2 text-white text-sm font-manrope font-bold px-[16.5px] py-[7px] rounded-[12px]"
                  >
                    Dashboard
                  </button>
                ) : (
                  <>
                    <Link
                      to="/login"
                      className="block text-center text-sm text-[#ffffff] hover:text-[#a5b4fc] transition-all font-light tracking-wide py-2 active:bg-[#1e3a8a]/20"
                      onClick={() => setIsResourcesOpen(false)}
                    >
                      LOGIN
                    </Link>
                    <Link
                      to="/signup"
                      className="block text-center text-sm text-[#FA6138] border border-[#FA6138]/30 px-5 py-2.5 rounded-full hover:bg-[#FA6138]/10 transition-all font-light active:bg-[#FA6138]/20"
                      onClick={() => setIsResourcesOpen(false)}
                    >
                      JOIN NOW
                    </Link>
                  </>
                )}
              </div>
            </div>
          </motion.div>
        )}
      </header>
    </div>
  );
};
